import React, {useMemo} from "react";
import {
  Grid,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import ParticipantsSearchBar from "./ParticipantsSearchBar";
import { useTranslator } from "../../context/TranslatorContext";

export default function ParticipantsFilters({
  searchQuery,
  setSearchQuery,
  setActiveSearch,
  euRegistered,
  setEuRegistered,
  euControlled,
  setEuControlled,
  country,
  setCountry,
  sortOrder,
  setSortOrder,
  participantData = [],
  facets = {},
  onReset,
}) {

  const { messages } = useTranslator();

  const registeredCount =
    facets?.filter_eu_registered?.buckets?.find(
        b => b.key === "true"
    )?.doc_count ?? 0;

  const controlledCount =
    facets?.filter_eu_controlled?.buckets?.find(
      b => b.key === "true"
    )?.doc_count ?? 0;
  // console.log("FACETS", facets);
  return (
      <Grid container sx={{ justifyContent: "flex-start", alignItems: "center", }}>
        <Grid item xs={12} sx={{p: 1}}>
          <ParticipantsSearchBar
            value={searchQuery}
            onChange={setSearchQuery}
            onSearch={setActiveSearch}
            placeholder={messages.searchParticipants ?? "Search participants..."}
          />
        </Grid>
        <Grid item container xs={12} sx={{p: 1}} justifyContent="flex-start">
        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={euRegistered}
                onChange={(e) =>
                  setEuRegistered(e.target.checked)
                }
              />
            }
            label={<Typography variant="body2"> {messages.eu_registered} {" "} ({registeredCount}) </Typography>}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={euControlled}
                onChange={(e) =>
                  setEuControlled(e.target.checked)
                }
              />
            }
            label={<Typography variant="body2"> {messages.eu_controlled} {" "} ({controlledCount}) </Typography>}
          />
        </Grid>

        <Grid item xs={12} md={2}>
            <FormControl size="small" sx={{ minWidth: 140 }}>
              <InputLabel> {messages.sort} </InputLabel>
              <Select
                value={sortOrder}
                label={messages.sort}
                onChange={(e) =>
                  setSortOrder(e.target.value)
                }
              >
                <MenuItem value="Asc"> A → Z </MenuItem>
                <MenuItem value="Desc"> Z → A </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <Button color="secondary" variant="outlined" onClick={onReset} sx={{float: "right"}}> {messages.reset ?? "Reset"}</Button>
          </Grid>
        </Grid>
      </Grid>

  );

}